<template>
    <div>
        <el-row>
            <el-col :offset="22">
                <el-button type="primary" v-if="Acs('/customer-quote/create')" @click="showAddDialog()">新增报价</el-button>
            </el-col>
        </el-row>
        <el-table :data="list" border v-loading="loading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-row class="searchSection">
                        <el-col :span="10">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="报价ID：">
                                    <span>{{ props.row.id }}</span>
                                </el-form-item>
                                <el-form-item label="客户名称：">
                                    <span>{{ props.row.customer_name }}</span>
                                </el-form-item>
                                <el-form-item label="意向产品：">
                                    <div v-for="(product_name, key) in props.row.product_names" :key="key"><el-button size="mini" type="primary">{{ product_name }}</el-button></div>
                                </el-form-item>
                                <el-form-item label="业务员：">
                                    <span>{{ props.row.user_name }}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col :span="10" :offset="4">
                            <el-form label-position="left" class="demo-table-expand">
                                <el-form-item label="客户联系人：">
                                    <span>{{ props.row.contact_name }}</span>
                                </el-form-item>
                                <el-form-item label="报价：">
                                    <span>{{ props.row.price }}</span>
                                </el-form-item>
                                <el-form-item label="创建时间：">
                                    <span>{{ props.row.created_at }}</span>
                                </el-form-item>
                                <el-form-item label="创建人：">
                                    <span>{{ props.row.operator_name }}</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="id" label="报价ID"></el-table-column>
            <el-table-column prop="products" label="报价产品">
                <template slot-scope="scope">
                    <div v-for="(product_name, key) in scope.row.product_names" :key="key"><el-button size="mini" type="primary">{{ product_name }}</el-button></div>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="报价"></el-table-column>
            <el-table-column prop="mode_name" label="合作方式"></el-table-column>
            <el-table-column prop="created_at" label="创建时间"></el-table-column>
            <el-table-column prop="user_name" label="业务员"></el-table-column>
            <el-table-column label="操作"  fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="Acs('/customer-quote/update')" @click="showUpdateDialog(scope.row)" type="text" size="small">编辑</el-button>
                    <el-button v-if="Acs('/customer-quote/delete')" @click="showDeleteDialog(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        <addQuote v-if="dialogAddQuote" :customer="customer" :model="model" :key="corpKey" @change="quoteDialogClose()"></addQuote>
    </div>
</template>
<style scoped>

</style>
<script>
    import CustomerQuote from "~/services/CustomerQuote";
    import addQuote from "~/views/customer/dialog/addQuote.vue";
    import MyPagination from "~/widgets/MyPagination.vue";
    export default {
        name: "Quote",
    
        components: {
            addQuote,
            MyPagination
        },
    
        props: {
            customer: {
                type: Object,
                required: true
            },
        },
    
        data() {
            return {
                loading: false,
                searcheModel: {
                    customer_id: '',
                },
                // 分页信息
                linkPage: null,
                list: [],
                dialogAddQuote: false,
                corpKey: 0,
                model: {},
            };
        },
    
        mounted() {},
    
        created: function () {
            this.searcheModel.customer_id = this.customer.id;
            this.getList(this.searcheModel);
        },
    
        methods: {
            //重置按钮
            resetForm() {
                this.searcheModel = {
                    customer_id: "",
                };
                this.list = [];
                this.submitSearch();
            },
        
            // 筛选查询
            submitSearch() {
                this.getList(this.searcheModel);
            },
        
            //获取列表
            getList(params) {
                // loading 动画
                this.loading = true;
                CustomerQuote.getList(params).then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                }).catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            showAddDialog(){
                this.model = {};
                this.dialogAddQuote = true;
                this.corpKey += 1;
            },

            showUpdateDialog(obj){
                this.model = obj;
                this.dialogAddQuote = true;
                this.corpKey += 1;
            },
        
            //删除客户的提示和数据处理。
            showDeleteDialog(obj) {
                this.$confirm("确定要删除该报价吗？删除后将无法找回", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    this.handleDelete(obj.id);
                })
            },

            //删除客户
            handleDelete(id) {
                CustomerQuote.delete(id).then(res => {
                    if(res && res.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                    }
                    this.submitSearch();
                }).catch((err) => {
                    console.error(err);
                });
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.searcheModel;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.searcheModel;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },

            quoteDialogClose(val){
                this.dialogAddQuote = false;
                this.submitSearch();
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/views/customer/Quote.vue